import type { ReactNode } from 'react';

export const symbol_screenshot_keyboard: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480.5-390q-37.5 0-64-26.44T390-480q0-38 26.44-64T480-570q38 0 64 26t26 63.5q0 37.5-26 64T480.5-390Zm106 16.5Q630-417 630-480t-43.5-106.5Q543-630 480-630t-106.5 43.5Q330-543 330-480t43.5 106.5Q417-330 480-330t106.5-43.5ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
